import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

export default new Router({
  mode: "history",
  routes: [{
    path: '/login',
    component: () => import('@/views/login.vue'),
    meta: {
      auth: false
    },
    children: [{
      path: '/login',
      name: 'Code',
      component: () => import('@/views/code.vue')
    }]
  }, {
    path: '/reg',
    name: 'Reg',
    component: () => import('@/views/reg.vue'),
    meta: {
      auth: false
    }
  }, {
    path: '/reset_password',
    name: 'ResetPassword',
    component: () => import('@/views/reset_password.vue'),
    meta: {
      auth: false
    }
  }, {
    path: '/',
    name: 'SystemIndex',
    component: () => import('@/views/system/index.vue'),
    meta: {
      auth: false,
      keepAlive: false
    },
    children: [{
      path: '/',
      name: 'SystemWelcome',
      component: () => import('@/views/system/welcome.vue'),
      meta: {
        auth: false,
        keepAlive: false
      }
    }, {
      path: '/system/product',
      name: 'SystemProduct',
      component: () => import('@/views/system/product.vue'),
      meta: {
        auth: false,
        keepAlive: false
      }
    }, {
      path: '/system/introduce',
      name: 'SystemIntroduce',
      component: () => import('@/views/system/introduce.vue'),
      meta: {
        auth: false,
        keepAlive: false
      }
    },{
      path: '/system/about_us',
      name: 'SystemAboutUs',
      component: () => import('@/views/system/about_us.vue'),
      meta: {
        auth: false,
        keepAlive: false
      }
    }, {
      path: '/system/software_purchase',
      name: 'SystemSoftwarePurchase',
      component: () => import('@/views/system/software_purchase.vue'),
      meta: {
        auth: false,
        keepAlive: false
      }
    }, {
      path: '/system/software_purchase_details',
      name: 'SystemSoftwarePurchaseDetails',
      component: () => import('@/views/system/software_purchase_details.vue'),
      meta: {
        auth: false,
        keepAlive: false
      }
    }, {
      path: '/system/value_added_services',
      name: 'ValueSddedServices',
      component: () => import('@/views/system/value_added_services.vue'),
      meta: {
        auth: false,
        keepAlive: false
      }
    }, {
      path: '/system/value_added_services_details',
      name: 'ValueSddedServicesDetails',
      component: () => import('@/views/system/value_added_services_details.vue'),
      meta: {
        auth: false,
        keepAlive: false
      }
    }]
  }, {
    path: '/company',
    name: '/CompanyIndex',
    component: () => import('@/views/company/index.vue'),
    meta: {
      auth: true
    },
    children: [{
      path: '/company/welcome',
      name: 'CompanyWelcome',
      component: () => import('@/views/company/welcome.vue'),
      meta: {
        auth: true,
        keepAlive: false
      }
    }, {
      path: '/company/basic_info',
      name: 'CompanyBasicInfo',
      component: () => import('@/views/company/basic_info.vue'),
      meta: {
        auth: true,
        keepAlive: false
      }
    }, {
      path: '/company/attestation',
      name: 'CompanyAttestation',
      component: () => import('@/views/company/attestation.vue'),
      meta: {
        auth: true,
        keepAlive: false
      }
    }, {
      path: '/company/current_service',
      name: 'CompanyCurrentService',
      component: () => import('@/views/company/current_service.vue'),
      meta: {
        auth: true,
        keepAlive: false
      }
    }, {
      path: '/company/invoice_management',
      name: 'CompanyInvoiceManagement',
      component: () => import('@/views/company/invoice_management.vue'),
      meta: {
        auth: true,
        keepAlive: false
      }
    }, {
      path: '/company/invoice_details',
      name: 'CompanyInvoiceDetails',
      component: () => import('@/views/company/invoice_details.vue'),
      meta: {
        auth: true,
        keepAlive: false
      }
    }, {
      path: '/company/invoice_details_info',
      name: 'CompanyInvoiceDetailsInfo',
      component: () => import('@/views/company/invoice_details_info.vue'),
      meta: {
        auth: true,
        keepAlive: false
      }
    }, {
      path: '/company/header_management',
      name: 'CompanyHeaderManagement',
      component: () => import('@/views/company/header_management.vue'),
      meta: {
        auth: true,
        keepAlive: false
      }
    }, {
      path: '/company/address_management',
      name: 'CompanyAddressManagement',
      component: () => import('@/views/company/address_management.vue'),
      meta: {
        auth: true,
        keepAlive: false
      }
    }, {
      path: '/company/purchase_record',
      name: 'CompanyPurchaseRecord',
      component: () => import('@/views/company/purchase_record.vue'),
      meta: {
        auth: true,
        keepAlive: false
      }
    }, {
      path: '/company/purchase_record_details',
      name: 'CompanyPurchaseRecordDetails',
      component: () => import('@/views/company/purchase_record_details.vue'),
      meta: {
        auth: true,
        keepAlive: false
      }
    }, {
      path: '/company/pay_detailes',
      name: 'CompanyPayDetailes',
      component: () => import('@/views/company/pay_detailes.vue'),
      meta: {
        auth: true,
        keepAlive: false
      }
    }, {
      path: '/company/personal_info',
      name: 'CompanyPersonalInfo',
      component: () => import('@/views/company/personal_info.vue'),
      meta: {
        auth: true,
        keepAlive: false
      }
    }, {
      path: '/company/account_management',
      name: 'CompanyAccountManagement',
      component: () => import('@/views/company/account_management.vue'),
      meta: {
        auth: true,
        keepAlive: false
      }
    }, ]
  }]
})